import  "./Montenegrin2022.css"

const Montenegrin2022 = ()=>{
     
    return (
    <>        
     
    </>
    )
}

export default Montenegrin2022;